import React, { FC } from 'react';

import {
  IconWrapper,
  PointsDescription,
  PointsLineWrapper,
  PointsText,
} from './transaction.styled';

export const PointsLine: FC<{
  points: number;
  description: string;
}> = ({ points, description }) => {
  const pointsEarned = points > 0;

  return (
    <PointsLineWrapper>
      <IconWrapper $pointsEarned={pointsEarned}>
        <PointsText $pointsEarned={pointsEarned}>{`${
          pointsEarned ? '+' : ''
        }${points}`}</PointsText>
      </IconWrapper>
      <PointsDescription>{description}</PointsDescription>
    </PointsLineWrapper>
  );
};
